import { AuditorCreationForm } from 'components/Pages/Auditors';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const AuditorCreationPage: React.FC = () => {
  const navigate = useNavigate();

  const onCreate = useCallback((): void => {
    navigate('/configuracoes/fiscais');
  }, [navigate]);

  return (
    <Scaffold>
      <AuditorCreationForm onCreate={onCreate} />
    </Scaffold>
  );
};
